@use '@lib/assets/styles/main.scss' as *;

@use '../Input/Input.module';

.groupRoot {
  position: relative;
  padding-bottom: 8px;
  display: flex;
}

.rootWithLabel {
  padding-top: 24px;
}

.tableWrap {
  @include scrollStyles;
  border-radius: 10px;
  overflow-x: auto;
  border: 1px solid $gray200;
}

.tableWrapWithErrpr {
  border-color: $error900;
}

.table {
  max-width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  td, th {
    padding-left: 16px;
    padding-right: 16px;
    min-width: 140px;
    border: 1px solid $gray200;
    &:not(.headerLabelColumn) {
      vertical-align: middle;
    }
    &:first-child {
      border-left: none;
    }
    &:last-child {
      border-right: none;
    }
  }
  thead {
    th {
      border-top: none;
    }
  }
  tr:last-child {
    td {
      border-bottom: none;
    }
  }
}

.headerLabelColumn {
  background: $gray10;
  color: $gray500;
  padding-top: 14px;
  padding-bottom: 14px;
  vertical-align: top;
}

.itemColumn {
  padding-top: 0;
  padding-bottom: 0;
}

.radioButton {
  margin: 0 auto;
  display: block;
  width: 48px;
}

.groupLabel {
  @extend .fieldLabel, .fieldLabelWhenText, .fieldLabelWhenValue;
  top: 0;
  transform: unset;
}

.tdContent {
  display: flex;
  align-items: center;
  &:not(.tdBtnContent) {
    max-width: 280px;
    min-width: 140px;
  }
}
